import React, { useEffect } from 'react';
import HeroSection from "js/components-v2/pages/BuyerPage/HeroSection";
import AppContent from "js/components/AppContent";
import LovePod from "js/components-v2/pages/BuyerPage/LovePod";
import BuyerTabs from "js/components-v2/pages/BuyerPage/BuyerTabs";
import { Link } from "@reach/router";
import { Footer } from 'js/new/Components/PageSections';

const BuyerPage2 = () => {
  useEffect(async () => {
    window.scrollTo(0, 0);
    await AppState.setCurrentPage('buyer2');
  }, []);

  return (
    <AppContent className="buyer-page">
      <div className="pod-hero-container pod-container">
        <div className="d-md-flex align-items-stretch">
          <HeroSection />
        </div>
      </div>
      <LovePod />
      <BuyerTabs />
      <Footer />
      <div className="buyer-bottom-button d-md-none d-grid">
        <Link to={'/buyer-signup'} className="btn btn-pod btn-primary">
          Start buying faster
        </Link>
      </div>
    </AppContent>
  );
}

export default BuyerPage2;
